
var shop ="";var customeremail=""; var customerid="";
var scripts = document.getElementsByTagName('script');
for(var i = 0, l = scripts.length; i < l; i++)
{
    if(scripts[i].getAttribute('data-shop-id')!=null)
    {           
        shop = scripts[i].getAttribute('data-shop-id');        
        customerid = scripts[i].getAttribute('data-customer-id');
        customeremail = scripts[i].getAttribute('data-customer-email');

    }
}


shop=Shopify.shop;
customerid = meta.page.customerId ? meta.page.customerId : "";

function ZooomyDataFun($zjqL,shop, customerid) {

    $zjqL.ajax({
        url: "https://zooomyapps.com/wishlist/ListWishlist.php",
        data: {
            shop: shop,
            customerid: customerid
        },
        dataType: "jsonp",
        jsonp: "ZooomyGetDataPage",
        async: "true",
        success: function(jsonData) {
            var usercss = jsonData.custom_css;
            var user_added_css = jsonData.user_added_css;
            var ids = jsonData.id;

            var product_id = jsonData.product_id;
            var product_price = jsonData.product_price;
            var product_handle = jsonData.product_handle;
            var product_name = jsonData.product_name;
            var product_img = jsonData.product_img;
            var wishlist_page_product_text = jsonData.wishlist_page_product_text;
            var wishlist_page_product_text_bg = jsonData.wishlist_page_product_text_bg;
            var wishlist_page_product_text_f_color = jsonData.wishlist_page_product_text_f_color;
            var wishlist_page_add_cart_text = jsonData.wishlist_page_add_cart_text;
            var wishlist_page_add_cart_text_f_color = jsonData.wishlist_page_add_cart_text_f_color;
            var wishlist_page_add_cart_text_bg = jsonData.wishlist_page_add_cart_text_bg;
            var remove_from_wishlist = jsonData.remove_from_wishlist;
            var remove_from_wishlist_f_color = jsonData.remove_from_wishlist_f_color;
            var remove_from_wishlist_bg = jsonData.remove_from_wishlist_bg;
            var layout = jsonData.layout;
            var shop_currency = jsonData.shop_currency;
            var shop_name = jsonData.shop_name;
            var sold_out_text = jsonData.sold_out_text;
            var directdelete = jsonData.directdelete;
            var cus_email = jsonData.cus_email;
            var zemail_e_btn = jsonData.zemail_e_btn;
            var zemail_textarea = jsonData.zemail_textarea;
            var zemail_s_btn = jsonData.zemail_s_btn;
            var frnd_name = jsonData.frnd_name;
            var frnd_email = jsonData.frnd_email;
            var frnd_name_bg = jsonData.frnd_name_bg;
            var frnd_name_f_color = jsonData.frnd_name_f_color;
            var variant_name = jsonData.variant_name;
            var empty_text = jsonData.empty_text;
            var pricing_plan = jsonData.plan;
            var product_handle = jsonData.product_handle;
            var show_vendor = jsonData.show_vendor;

            var sharedata = "qyghbced" + customerid + "azhu607h";
            var savdatawp = jsonData.savdatawp;
            var wish_icon = jsonData.savdatawp;
            wishlist_page_add_cart_text = wishlist_page_add_cart_text.replace("&Oslash;", "Ø");
            wishlist_page_add_cart_text = wishlist_page_add_cart_text.replace("&Aring;", "Å");
            wishlist_page_add_cart_text = wishlist_page_add_cart_text.replace("&AElig;", "Æ");
            wishlist_page_add_cart_text = wishlist_page_add_cart_text.replace("&oslash;", "ø");
            wishlist_page_add_cart_text = wishlist_page_add_cart_text.replace("&aring;", "å");
            wishlist_page_add_cart_text = wishlist_page_add_cart_text.replace("&aElig;", "æ");

            wishlist_page_product_text = wishlist_page_product_text.replace("&Oslash;", "Ø");
            wishlist_page_product_text = wishlist_page_product_text.replace("&Aring;", "Å");
            wishlist_page_product_text = wishlist_page_product_text.replace("&AElig;", "Æ");
            wishlist_page_product_text = wishlist_page_product_text.replace("&oslash;", "ø");
            wishlist_page_product_text = wishlist_page_product_text.replace("&aring;", "å");
            wishlist_page_product_text = wishlist_page_product_text.replace("&aElig;", "æ");

            remove_from_wishlist = remove_from_wishlist.replace("&Oslash;", "Ø");
            remove_from_wishlist = remove_from_wishlist.replace("&Aring;", "Å");
            remove_from_wishlist = remove_from_wishlist.replace("&AElig;", "Æ");
            remove_from_wishlist = remove_from_wishlist.replace("&oslash;", "ø");
            remove_from_wishlist = remove_from_wishlist.replace("&aring;", "å");
            remove_from_wishlist = remove_from_wishlist.replace("&aElig;", "æ");
            var data = [];

            if (customerid == "") {
                if (jsonData.w_login == "yes") {
                    $zjqL("<div class='zwishmsgs'><a href='https://" + shop_name + "/account/login' target='"+jsonData.open_link_tab+"' class='zmsg' style='float:left;width:100%;text-align:center;padding:10px 0;text-decoration:none;'>" + jsonData.login_save + "</a></div>").insertBefore('#ZoomyWishlistPage');

                    //$zjqL("#ZoomyWishlistPage").append();

                    var pidsall = [];
                    var producthandle = [];
                    var ptitle = [];
                    var pprice = [];
                    var pimg = [];
                    var vname = [];

                    if (localStorage.getItem("myzooomy__wishlist") == undefined) {} else {
                        var myJSON = "";
                        var nnitem = localStorage.getItem("myzooomy__wishlist");
                        data = JSON.parse(nnitem);

                        $zjqL.each(data, function(key, value) {
                            pidsall.push(value.product_id);
                            producthandle.push(value.product_handle);
                            pprice.push(value.proprice);
                            ptitle.push(value.protitle);
                            pimg.push(value.proimage);
                            vname.push(value.vname);



                        });
                    }
                    var ids = pidsall;

                    var product_id = pidsall;
                    var product_handle = producthandle;
                    var product_price = pprice;
                    var product_name = ptitle;
                    var product_img = pimg;
                    var variant_name = vname;
                } else {

                    $zjqL("#ZoomyWishlistPage").append("<div class='zwishmsgs'><a href='https://" + shop_name + "/account/login' target='_blank' class='zmsg'>" + jsonData.login_text + "</a></div>");


                }

            }


            $zjqL('<link rel="stylesheet" type="text/css" href="https://zooomyapps.com/wishlist/WishlistStyle.css">').appendTo("body");
            $zjqL('<style>' + usercss + '</style>').appendTo('body');
        if(jsonData.hide_cart_btn=="yes")
            {
            $zjqL('<style>span#wishlist_page_product_text { width: 100%; }</style>').appendTo('body');
        }

        $zjqL('<style>span#opencart a { float: right; position: absolute; top: -64px; right: 50px; }span#opencart { float: right; width: 100%; position: relative; }</style>').appendTo('body');
            $zjqL('<style>.ZoomyWishlistPagecol li.zbodyaction { width: 42%; }.ZoomyWishlistPagecol li.zbodytitle { width: 31%; }.ZoomyWishlistPagecol li.zbodypimg { width: 20%; }.ZoomyWishlistPagecol li.zbodysno { width: 7%; } .ZoomyWishlistPagecol li.zheadaction { width: 42%; }.ZoomyWishlistPagecol li.zheadtitle { width: 31%; }.ZoomyWishlistPagecol li.zheadpimg { width: 20%; }.ZoomyWishlistPagecol li.zheadsno { width: 5%; }.ZoomyWishlistPagecol a, .rte .ZoomyWishlistPagecol a{border:none; outline:none;}.ZoomyWishlistPagecol button{padding: 10px 20px; margin: 2px 3px;border:none;}#wishlist_page_product_text{background:' + wishlist_page_product_text_bg + '; color:' + wishlist_page_product_text_f_color + '; }#wishlist_page_product_text a{color:' + wishlist_page_product_text_f_color + '; }</style>').appendTo('body');
            $zjqL('<style>.zopencartlink{background:' + wishlist_page_add_cart_text_bg + '; color:' + wishlist_page_add_cart_text_f_color + ';border: none; padding: 1px 10px; }</style>').appendTo('body');
            $zjqL('<style>.zremovefromwish{background:' + remove_from_wishlist_bg + '; color:' + remove_from_wishlist_f_color + '; }</style>').appendTo('body');
            if (cus_email == "false" || customerid == "") {
                $zjqL('<style>#zooomyemailfbtn{display:none;}</style>').appendTo('body');
            }
            $zjqL('<style>.ZoomyWishlistPagecol li{float:left; width:25%; box-sizing:border:box; padding:10px; }.ZoomyWishlistPagecol{float: left; width: 100%;margin-bottom:10px; border-bottom:1px solid #ededed;}</style>').appendTo('body');


            if (product_id == 0 || product_id == "0" || product_id == null || product_id == "null") {
                if (jsonData.w_login == "no") {
                    if (customerid != "") {
                        if ($zjqL(".zmsg").length == 0) {
                            $zjqL("#ZoomyWishlistPage").append("<div class='zwishemptymsg'><p class='zmsg'>" + empty_text + "</p></div>");

                        } else {
                            $zjqL("#ZoomyWishlistPage .zmsg").replaceWith("<div class='zwishemptymsg'><p class='zmsg'>" + empty_text + "</p></div>");

                        }
                    }
                } else {
                    $zjqL("#ZoomyWishlistPage").append("<div class='zwishemptymsg'><p class='zmsg'>" + empty_text + "</p></div>");
                }

                $zjqL('<style>.ZoomyWishlistPagecol{display:none;}</style>').appendTo('body');
            }
            $zjqL("#ZoomyWishlistPage").before("<span class='zooomyaddtowishlistmsg' style='float:left;width:100%;'></span>");
            if (pricing_plan != "nfree" || pricing_plan != "free") {
                $zjqL("#ZoomyWishlistPage").before("<span class='zooomybtn' id='zooomyemailfbtn' style='cursor:pointer;border: none;float:left; width:100%;'><a id='emailzwishlist' class='' style='background:" + frnd_name_bg + "; color:" + frnd_name_f_color + ";'>" + zemail_e_btn + "</a></span>"); 
                $zjqL("#ZoomyWishlistPage").before("<div id='zemaildata' style='display:none;'><form><input type='text' id='zemailname'  placeholder='" + frnd_name + "' required/><input type='email' id='zemailid'   placeholder='" + frnd_email + "'  required/><textarea id='zemailmsg' required> " + zemail_textarea + " </textarea><a id='zsendemail'>" + zemail_s_btn + "</a></form></div>");
                if (cus_email == true || cus_email == "true") {
                    $zjqL(".zooomybtn").append('<div class="z_social_share_wishlist"><a class="zooomylink_fa"><i class = "fa fa-link"></i></a><a class="zsocial_icon" href="https://www.facebook.com/sharer/sharer.php?u=https://' + shop_name + '/pages/share-wish-list?' + sharedata + '&t=Wishlist" onclick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Facebook"><i class="fa fa-facebook"></i><a class="zpinicon" href="http://pinterest.com/pin/create/button/?url=https://' + shop_name + '/pages/share-wish-list?' + sharedata + '&media=" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Pinterest"><i class="fa fa-pinterest"></i></a><a class="zwhatsappicon" href="whatsapp://send?text=https://' + shop_name + '/pages/share-wish-list?' + sharedata + '" data-action="share/whatsapp/share" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on whatsapp"><i class="fa fa-whatsapp"></i></a><a href="mailto:?subject=' + frnd_name + '&body=' + zemail_textarea + ': https://' + shop_name + '/pages/share-wish-list?' + sharedata + '" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Mail" class="zsemailicon"><i class="fa fa-envelope"></i></a></div>');
                }
                $zjqL('<style> .z_social_share_wishlist .fa{background:' + frnd_name_bg + '; color:' + frnd_name_f_color + ';border:none;}</style>').appendTo('body');
                $zjqL("#ZoomyWishlistPage").before("<textarea id='zooomycopytxtarea'  style='display:none;margin:10px 0;float: left; width: 100%; text-align: center; padding: 10px; height: 58px; min-height: 20px; border: 1px solid #eee; font-size: 18px; color: #888;'>https://" + shop_name + "/pages/share-wish-list?" + sharedata + "</textarea>");

            }

            $zjqL('<style> #zsendemail{background:' + frnd_name_bg + '; color:' + frnd_name_f_color + ';border:none;}</style>').appendTo('body');




            if (layout == "list") {
                $zjqL("#ZoomyWishlistPage").addClass("zooomywishlistlistclass");
            } else {
                $zjqL("#ZoomyWishlistPage").addClass("zooomywishlistgridclass");

            }
            $zjqL('<style>.zooomybtn.removefromwishlist.zremovefromwish{ cursor: pointer; border: none; padding: 0; margin: 0; box-sizing: border-box; line-height: 25px; height: 25px; width: 25px;}.ZoomyWishlistPageGrid span.zooomybtn { cursor:pointer;border: none; margin: 2px; padding: 4px 10px; margin-top: 20px; box-sizing: border-box; }.ZoomyWishlistPageGrid{float: left; width: 31.3%; box-sizing: border-box; position: relative; text-align: center; margin: 10px 1%; border: 1px solid #efefef; padding: 20px;}</style>').appendTo('body');

            $zjqL('<style>.ZoomyWishlistPageGrid .removefromwishlist {position: absolute; right: 0px; top:0;border: 0; background: ' + remove_from_wishlist_bg + ';color:' + remove_from_wishlist_f_color + '; padding: 0; margin: 0; line-height: 20px; height: 24px; width: 23px; text-align: center; }</style>').appendTo('body');
            $zjqL.each(ids, function(i, v) {
                $zjqL("#ZoomyWishlistPage").append("<div class='ZoomyWishlistPageGrid' id='ZoomyWishlistPageGrid-" + product_id[i] + "'> <li class='zbodypimg'><a target='_blank' href='https://" + jsonData.shop_name + "/products/" + product_handle[i] + "'><img src='" + product_img[i] + "' width='100'></a></li><li class='zbodytitle'><a href='https://" + jsonData.shop_name + "/products/" + product_handle[i] + "'>" + product_name[i] + "</a></li><li class='zbodyaction'><span class='zooomybtn'  id='wishlist_page_product_text'><a href='https://" + jsonData.shop_name + "/products/" + product_handle[i] + "'>" + wishlist_page_product_text + "</a></span></li></div>");
            if(jsonData.hide_cart_btn!="yes")
            {
                            $zjqL("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + product_id[i] + " .zbodyaction").append("<button id='" + product_id[i] + "' class='zbtn zooomybtn addcartbtn zopencartlink' value='" + product_handle[i] + "' data-pro-id='" + product_id[i] + "'>" + wishlist_page_add_cart_text + "</button>");

            }
                
                $zjqL("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + product_id[i] + " .zbodypimg").prepend("<button id='rmvfrmwish" + product_id[i] + "' class='zooomybtn removefromwishlist zremovefromwish' value='" + product_id[i] + "'>x</button>");
                $zjqL("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + product_id[i] + " .zbodytitle").after("<li class='zbodyinfo'><div class='zoptionbox' style='float:left;width:100%;margin:10px 0px;'><select class='zooomyshopvariant' id='zooomyshopvariant-" + product_id[i] + "'></select></div><div class='zqty'><select id='zqtyn-" + product_id[i] + "'><option value='1'>1</option><option value='2'>2</option><option value='3'>3</option><option value='4'>4</option><option value='5'>5</option><option value='6'>6</option><option value='7'>7</option><option value='8'>8</option><option value='9'>9</option><option value='10'>10</option></select></div></li>");
                var cartlink = 'https://' + jsonData.shop_name + '/cart';


                $zjqL.ajax({
                    url: '/products/' + product_handle[i] + '.js',
                    dataType: 'json',
                    success: function(cartvalues) {
                        console.log("...",cartvalues);
                        var variantprice = cartvalues.variants[0].price;
                        var ava = cartvalues.variants.available;
                         if (show_vendor == "yes") 
                        {
                        
                        $zjqL("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + product_id[i] + " .zbodytitle").append('<div class="zpro_vendor">'+cartvalues.vendor+'</div>');

                         }

                        if (ava == undefined) {
                            var ava = cartvalues.available;

                        }
                        if (ava == false) {
                            $zjqL("button#" + product_id[i]).text(sold_out_text);
                            $zjqL("button#" + product_id[i]).addClass("z_w_soldout");

                        } else {
                            $zjqL("button#" + product_id[i]).text(wishlist_page_add_cart_text);
                            $zjqL("button#" + product_id[i]).removeClass("z_w_soldout");

                        }
                        variantprice = (variantprice) / 100;

                        variantprice = variantprice.toFixed(2);
                        if (shop_name == "jens-gullsmidur.myshopify.com") {
                            variantprice = variantprice * 100;
                        }
                        if (shop_name == "hello-sasha.myshopify.com") {
                            variantprice = variantprice + shop_currency;

                        } else {
                            variantprice = shop_currency + variantprice;

                        }


                        $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zbodytitle").after("<span class='zprice' style='float:left; width:100%;'>" + variantprice + "</span>");

                        $zjqL(cartvalues.variants).each(function(k, variants) {
                            var showselect = variants.title;
                            if (variants.featured_image == null) {
                                vimg = "";
                            } else {
                                vimg = variants.featured_image.src;
                            }
                            $zjqL("#zooomyshopvariant-" + product_id[i]).append("<option id='" + variants.id + "'  data-id='" + variants.id + "'  value='" + variants.title + "' data-image='" + vimg + "' data-price='" + variants.price + "'  data-available='" + variants.available + "' >" + variants.title + "</option>");
                            if (showselect == "Default Title")

                            {
                                $zjqL("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + product_id[i] + " .zoptionbox").hide();

                            }



                            var dropdown = $zjqL("#zooomyshopvariant-" + product_id[i]);
                            var selectedText = dropdown.find("option:selected").text();
                            var vavailable = dropdown.find('option:selected').attr('data-available');
                            if (vavailable == "false") {
                                $zjqL("button#" + product_id[i]).text(sold_out_text);
                                $zjqL("button#" + product_id[i]).addClass("z_w_soldout");

                            } else {
                                $zjqL("button#" + product_id[i]).text(wishlist_page_add_cart_text);
                                $zjqL("button#" + product_id[i]).removeClass("z_w_soldout");

                            }




                        });

                        variant_name[i] = ( typeof variant_name[i] == null)?'': variant_name[i].trim();

                        if (variant_name[i] != "") {

                            $zjqL("#zooomyshopvariant-" + product_id[i]).val(variant_name[i]);
                            var dropdown = $zjqL("#zooomyshopvariant-" + product_id[i]);
                            var selectedText = dropdown.find("option:selected").text();
                            var imgg = dropdown.find('option:selected').attr('data-image');
                            var vprice = dropdown.find('option:selected').attr('data-price');
                            var vavailable = dropdown.find('option:selected').attr('data-available');
                            if (vavailable == "false") {
                                $zjqL("button#" + product_id[i]).text(sold_out_text);
                                $zjqL("button#" + product_id[i]).addClass("z_w_soldout");

                            } else {
                                $zjqL("button#" + product_id[i]).text(wishlist_page_add_cart_text);
                                $zjqL("button#" + product_id[i]).removeClass("z_w_soldout");

                            }
                            if (imgg != "") {
                                $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zbodypimg img").attr('src', imgg);
                            }
                            vprice = (vprice) / 100;
                            vprice = vprice.toFixed(2);
                            if (shop_name == "hello-sasha.myshopify.com") {
                                vprice = vprice + shop_currency;

                            } else {
                                vprice = shop_currency + vprice;

                            }
                            if (vprice == undefined || vprice == "$NaN") {

                            } else {

                                $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zprice").replaceWith("<span class='zprice'>" + vprice + "</span>");
                            }
                            if (vavailable) {

                            } else {
                                $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zavailable").replaceWith("<span class='zavailable' style='float: left; width: 100%;'>" + vavailable + "</span>");

                            }
                        }
                        if (variant_name[i] == "") {
                            $zjqL("#zooomyshopvariant-" + product_id[i]).val(cartvalues.variants[0].title);


                        }



                        $zjqL("#zooomyshopvariant-" + product_id[i] + "  option").each(function() {
                            if (this.value == 'Default Title') {

                                $zjqL("#zooomyshopvariant-" + product_id[i]).val("Default Title");

                            }
                        });


                        $zjqL("#ZoomyWishlistPageGrid-" + product_id[i]).change(function() {


                            var dropdown = $zjqL("#zooomyshopvariant-" + product_id[i]);
                            var selectedText = dropdown.find("option:selected").text();
                            var imgg = dropdown.find('option:selected').attr('data-image');
                            var vprice = dropdown.find('option:selected').attr('data-price');
                            var vavailable = dropdown.find('option:selected').attr('data-available');
                            var vid = dropdown.find('option:selected').attr('data-id');

                            if (vavailable == "false") {
                                $zjqL("button#" + product_id[i]).text(sold_out_text);
                                $zjqL("button#" + product_id[i]).addClass("z_w_soldout");

                            } else {
                                $zjqL("button#" + product_id[i]).text(wishlist_page_add_cart_text);
                                $zjqL("button#" + product_id[i]).removeClass("z_w_soldout");

                            }
                            vprice = (vprice) / 100;
                            vprice = vprice.toFixed(2);
                            if (shop_name == "hello-sasha.myshopify.com") {
                                vprice = vprice + shop_currency;

                            } else {
                                vprice = shop_currency + vprice;

                            }



                            if (imgg != "") {
                                $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zbodypimg img").attr('src', imgg);
                            }

                            $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zprice").replaceWith("<span class='zprice'>" + vprice + "</span>");
                            $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zavailable").replaceWith("<span class='zavailable' style='float: left; width: 100%;'>" + vavailable + "</span>");
                            if (savdatawp == "yes") {
                                $zjqL.ajax({
                                    url: "https://zooomyapps.com/wishlist/ZooomySaveDataWishlist.php",
                                    data: {
                                        shop: shop,
                                        productid: product_id[i],
                                        customerid: customerid,
                                        vid: vid,
                                        vname: selectedText,
                                        vprice: vprice
                                    },
                                    dataType: "jsonp",
                                    jsonp: "savemydata",
                                    async: "true",
                                    success: function(njData) {

                                        $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .zoptionbox").append("<p class='zsavdatamsg' style='font-size: 12px;  position: absolute; text-align: center; width: 100%; margin: 0; padding: 0; box-sizing: border-box; left: 4px;'>" + njData.datasaved + "</p>");
                                        setTimeout(function() {
                                            $zjqL('.zsavdatamsg').fadeOut('slow');
                                        }, 350);

                                    }
                                });

                            }

                        });



                        $zjqL("#ZoomyWishlistPageGrid-" + product_id[i] + " .addcartbtn").click(function() {

                            var dropdown = $zjqL("#zooomyshopvariant-" + product_id[i]);
                            var selectedText = dropdown.find("option:selected").text();
                            if (selectedText == "") {

                                alert("Please select value from dropdown");

                            }
                            var imgg = dropdown.find('option:selected').attr('data-image');
                            var wishlistid = $zjqL(this).attr('data-pro-id');

                            var selectedValue = dropdown.find('option:selected').attr('data-id');


                            var ndropdown = $zjqL("#zqtyn-" + product_id[i]);
                            var nselectedText = ndropdown.find("option:selected").text();
                            var nzqtyval = ndropdown.val();
                            if (selectedValue == undefined) {
                                selectedValue = product_id[i];
                            }

                            zooomywishlistpage(product_id[i], customeremail, customerid);


                            $zjqL.ajax({
                                type: 'POST',
                                url: '/cart/add.js',
                                dataType: 'json',
                                data: {
                                    quantity: nzqtyval,
                                    id: selectedValue,
                                },
                                success: function(a) {


                                    $zjqL.getJSON('/cart.js', function(cart) {


                                        if (directdelete == "true") {
                                            var wishlistid = product_id[i];
                                            data = data.filter(product => {
                                                return product.product_id != wishlistid
                                            });
                                            $zjqL(".zooomyaddtowishlistmsg").append('<span id="zooomyitemadded"><a href=' + cartlink + '>' + jsonData.open_cart_text + '</a></span>');

                                            $zjqL('#zooomyitemadded').each(function() {
                                                $zjqL('[id="' + this.id + '"]:gt(0)').remove();
                                            });
                                            var addtocart = "yes";
                                            $zjqL.ajax({
                                                url: "https://zooomyapps.com/wishlist/RemoveFromWishlist.php",
                                                data: {
                                                    shop: shop,
                                                    productid: wishlistid,
                                                    customerid: customerid,
                                                    addtocart: addtocart
                                                },
                                                dataType: "jsonp",
                                                jsonp: "mylinkprocode",
                                                async: "true",
                                                success: function(njsonData) {
                                                    pid = njsonData.productid;
                                                    $zjqL('#ZoomyWishlistPageGrid-' + pid).remove();
                                                    $zjqL('#ZoomyWishlistPagecol-' + pid).remove();



                                                }
                                            });
                                            myJSON = JSON.stringify(data);
                                            if (jsonData.refresh_cart == "yes") {
                                                location.reload();
                                            }

                                            localStorage.setItem("myzooomy__wishlist", myJSON);
                                            if ($zjqL('#zooomy-wishlist-counter').length) {

                                                document.getElementById("zooomy-wishlist-counter").innerHTML = ($zjqL('.ZoomyWishlistPageGrid').length) - 1;
                                            }


                                        } else {
                                            $zjqL("button#" + product_id[i]).replaceWith('<button id="' + product_id[i] + '" class="zooomybtn addcartbtn zopencartlink" value=""><a href="' + cartlink + '" style="color:' + wishlist_page_add_cart_text_f_color + '">' + jsonData.open_cart_text + '</a></button>');
                                            if (jsonData.refresh_cart == "yes") {
                                                location.reload();
                                            }
                                        }

                                    });

                                },

                            });

                        });

                    },
                    error: function(cartvalues) {
                        $zjqL("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + product_id[i]).hide();
                    },


                });

            });




            $zjqL('.removefromwishlist').click(function() {
                var wishlistid = $zjqL(this).val();
                data = data.filter(product => {
                    return product.product_id != wishlistid
                });

                $zjqL.ajax({
                    url: "https://zooomyapps.com/wishlist/RemoveFromWishlist.php",
                    data: {
                        shop: shop,
                        productid: wishlistid,
                        customerid: customerid
                    },
                    dataType: "jsonp",
                    jsonp: "mylinkprocode",
                    async: "true",
                    success: function(njsonData) {
                        pid = njsonData.productid;
                        $zjqL('#ZoomyWishlistPageGrid-' + pid).remove();
                        $zjqL('#ZoomyWishlistPagecol-' + pid).remove();

                    }
                });
                myJSON = JSON.stringify(data);

                localStorage.setItem("myzooomy__wishlist", myJSON);
                if ($zjqL('#zooomy-wishlist-counter').length) {
                    document.getElementById("zooomy-wishlist-counter").innerHTML = ($zjqL('.ZoomyWishlistPageGrid').length) - 1;

                }
            });

            $zjqL("#emailzwishlist").click(function() {
                $zjqL("#zemaildata").slideToggle('100');

            });
            $zjqL("#zsendemail").click(function() {
                var zemailid = $zjqL("#zemailid").val();
                var zemailname = $zjqL("#zemailname").val();
                var zemailmsg = $zjqL("#zemailmsg").val();
                if (zemailname == "") {
                    $zjqL("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwsubject'>Add Subject.</span>");
                }
                if (zemailid == "") {
                    $zjqL("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwemail'>Add Email address.</span>");
                }
                if (zemailid != "" && zemailname != "") {
                    var getcusid = customerid;

                    $zjqL.ajax({
                        url: "https://zooomyapps.com/wishlist/ZooomyEmailList.php?shop=" + shop + "&getcusid=" + getcusid + "&zemailid=" + zemailid,
                        data: {
                            shop: shop,
                            getcusid: getcusid,
                            zemailid: zemailid,
                            zemailname: zemailname,
                            zemailmsg: zemailmsg
                        },
                        dataType: "jsonp",
                        jsonp: "jsonDataCode",
                        async: "true",
                        success: function(ejsonData) {
                            var emailed = ejsonData.emailed;
                            if (emailed == "sent") {



                            }

                        }
                    });
                    $zjqL("#zemaildata").slideToggle('100');
                    $zjqL("#emailzwishlist").before("<span class='emailsentz'>Email has been sent</span>");

                }
            });

            $zjqL(".zooomylink_fa").click(function() {
                $zjqL("#zooomycopytxtarea").fadeIn(1000);
                setTimeout(function() {
                    $zjqL("#zooomycopytxtarea").fadeOut(400);

                }, 15000);

            });
            if (cus_email == "false" || customerid == "") {
                $zjqL("#zooomyemailfbtn").on("mouseover", function() {

                });
            }

            function zooomywishlistpage(zpagepid, customeremail, customerid) {

                if (localStorage.getItem("ZwishlistPageEmail") == undefined || localStorage.getItem("ZwishlistPageEmail") == "") {
                    var customeremail = customeremail;
                } else {
                    var zooomywishlists = localStorage.getItem("ZwishlistPageEmail");

                }
                localStorage.setItem("ZwishlistPageEmail", customeremail);

                if (localStorage.getItem("ZwishlistPageid") == undefined || localStorage.getItem("ZwishlistPageid") == "") {
                    var customerid = customerid;

                } else {
                    var zooomywishlists = localStorage.getItem("ZwishlistPageId");

                }
                localStorage.setItem("ZwishlistPageId", customerid);


                if (localStorage.getItem("ZwishlistpageproIds") == undefined) {
                    var productids = zpagepid;
                } else {
                    var zooomywishlistpages = localStorage.getItem("ZwishlistpageproIds");
                    if (zooomywishlistpages.indexOf(zpagepid) > -1) {
                        var productids = zpagepid;
                    } else {
                        var productids = zooomywishlistpages + "," + zpagepid;
                    }
                }
                localStorage.setItem("ZwishlistpageproIds", productids);
                return true;



            }
            if (jsonData.shop_id > 25236) {
                $zjqL('<style>.zooomywishlistgridclass img { width: 100%; }a#emailzwishlist { display: none; }.zooomywishlistgridclass  .ZoomyWishlistPageGrid span.zooomybtn, .zopencartlink {border-radius:0px; margin: 10px auto;  float: left;width: 100%;}.ZoomyWishlistPageGrid span.zooomybtn { margin: 2px 0 0!important; }.ZoomyWishlistPageGrid span.zooomybtn { margin: 2px 0 0!important; text-align: center; cursor: pointer; font-family: inherit; font-weight: normal; font-style: normal; font-size: 15px; padding: 10px; text-transform: uppercase; letter-spacing: 3px;} .Product__QuickNav{clear: both;}.z_social_share_wishlist { float: none; width: 175px; margin: 0 auto; }a#emailzwishlist { display: none; }.zooomy__hhrt{display:none;}.zooomybtn.removefromwishlist.zremovefromwish{min-width:0;}.z_social_share_wishlist a, #ZoomyWishlistPage a { font-size: 15px; }.zbodyaction .zopencartlink { padding: 10px 10px; font-family: inherit; font-size: 15px; font-weight: normal; height: auto; }.ZoomyWishlistPageGrid span.zooomybtn, .zopencartlink { padding: 9px 20px; font-family: inherit; letter-spacing: 0; text-transform: inherit;}.zooomyshopvariant{width:100%;}#ZoomyWishlistPage a.zmsg { color: #000; margin-bottom: 40px; }.template-page .rte.reading-width { max-width: 100%; }.zooomywishlistgridclass .ZoomyWishlistPageGrid .zbodyaction span.zooomybtn { padding: 10px 10px; width: 100%; float: left; }div#shopify-section-framework--footer { clear: both; }.zooomywishlistlistclass .zbodyaction .zopencartlink { width: auto; }</style>').appendTo('body');
                if (layout == "list") {
                    $zjqL('<style>.zooomywishlistgridclass .ZoomyWishlistPageGrid span.zooomybtn, .zopencartlink { width: auto; margin: 0 10px; float: none; padding-top:9px;}</style>').appendTo('body');

                }

            }



            $zjqL('<style>' + user_added_css + '</style>').appendTo('body');
            numItems = $zjqL('.ZoomyWishlistPageGrid').length;
            if ($zjqL('.zooomyIconval').length) {
                if (numItems > 0) {
                    $zjqL('.zooomyIconval i.fa').addClass('fa-heart').removeClass('fa-heart-o');
                }
            }

            if ($zjqL('#zooomy-wishlist-counter').length) {
                document.getElementById("zooomy-wishlist-counter").innerHTML = numItems;
            }


        }
    });
}

function reqJqueryList() {
        if ("undefined" == typeof jQuery || !jQuery || 1 === parseInt(jQuery.fn.jquery) && parseFloat(jQuery.fn.jquery.replace(/^1\./, "")) < 10) {
            
            var e = document.getElementsByTagName("head")[0],
                    n = document.createElement("script");
            n.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js", n.type = "text/javascript", n.onload = n.onreadystatechange = function () {
                n.readyState ? "complete" !== n.readyState && "loaded" !== n.readyState || (n.onreadystatechange = null, ZooomyDataFun(jQuery.noConflict(!0),shop, customerid)) : ZooomyDataFun(jQuery.noConflict(!0),shop, customerid)
            }, e.appendChild(n)

        } else ZooomyDataFun(jQuery,shop, customerid)
    }
reqJqueryList() 